export const isContextValid = (applicationContext, onError) => {
    if (!applicationContext) {
        const errorMessage = 'applicationContext must be provided';
        if (onError == null) {
            console.error(errorMessage);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(errorMessage);
        }
        return false;
    }
    if (!('authToken' in applicationContext) ||
        applicationContext.authToken === undefined ||
        applicationContext.authToken === null ||
        applicationContext.authToken.trim().length === 0) {
        const errorMessage = 'ApplicationContext.authToken must be provided';
        if (onError == null) {
            console.error(errorMessage);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(errorMessage);
        }
        return false;
    }
    if (!('sdkEnvironment' in applicationContext) ||
        applicationContext.sdkEnvironment === undefined ||
        applicationContext.sdkEnvironment === null) {
        const errorMessage = 'ApplicationContext.sdkEnvironment must be set to start the aprilSDK';
        if (onError == null) {
            console.error(errorMessage);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(errorMessage);
        }
        return false;
    }
    return true;
};
